export class IFrame {
    constructor(container) {
        this.container = container;
    }
    load(link, options = {}) {
        if (!this.container.isExist() || this.isExist())
            return;
        let iFrame = document.createElement('iframe');
        iFrame.setAttribute('src', link);
        if (options.title)
            iFrame.title = options.title;
        this.container.getElement().appendChild(iFrame);
    }
    loadFromHtml(content, options = {}) {
        if (!this.container.isExist() || this.isExist())
            return;
        let iFrame = document.createElement('iframe');
        iFrame.setAttribute('height', '100%');
        iFrame.setAttribute('width', '100%');
        if (options.title)
            iFrame.title = options.title;
        const template = "<html><head><style>html, body {margin: 0;} iframe {border: 0; width: 100%}</style><title></title></head><body>{{content}}</body></html>";
        this.container.getElement().appendChild(iFrame);
        let iFrameDocument = this.getElement().contentDocument;
        iFrameDocument.open();
        iFrameDocument.write(template.replace('{{content}}', content));
        iFrameDocument.close();
    }
    remove() {
        if (!this.container.isExist() || !this.isExist())
            return;
        let iFrame = this.getElement();
        this.container.getElement().removeChild(iFrame);
    }
    show() {
        if (!this.isExist())
            return;
        this.setStyle('visibility', 'visible');
        this.setStyle('display', 'block');
    }
    hide(saveSize = false) {
        if (!this.isExist())
            return;
        if (saveSize)
            this.setStyle('visibility', 'hidden');
        else
            this.setStyle('display', 'none');
    }
    isExist() {
        return !!(this.getElement());
    }
    getElement() {
        if (!this.container.isExist())
            return null;
        return this.container.getElement().querySelector('iframe');
    }
    setStyle(property, value) {
        let iFrame = this.getElement();
        iFrame.style[property] = value;
    }
}
//# sourceMappingURL=../../src/lib/components/iframe.js.map